<template>
  <committee-profile-details :committeeDetails="committeeDetails" :isLoading="isLoading" class="tab-pane row mx-0 show active"/>
</template>

<script>
import tabLayout from '@/components/TabLayout'
import committeeProfileDetails from './CommitteeProfileDetails'
import committeeSecretaries from './components/CommitteeSecretaries'
import CommitteeAffiliation from "./components/CommitteeAffiliation"

export default {
  name: 'CommitteeProfile',
  props: ['committeeDetails', 'isLoading'],
  components: {
    'tab-layout': tabLayout,
    'committee-profile-details': committeeProfileDetails,
    'committee-secretaries': committeeSecretaries,
    'committee-affiliation': CommitteeAffiliation
  },
  data() {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Profile/CommitteeProfileAllDetails.vue